import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDHeadlineText } from '@facet-wealth/design';
import { Stepper } from './stepper';

export const buildBaseOverrides = () => buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'lg', align: 'center' },
  }, overrideReadOnly)
  .nameOverride('stepper', {
    _component: () => Stepper,
  }, overrideReadOnly);
